module.exports = __webpack_public_path__ + "static/landing_build_mimi-a5306c636e8d5f32385ade45e3b5047c.svg";